import { SEARCH_DOMAIN_TYPE_CODE, CONST_SEARCH_FIELD_CODE, SEARCH_FIELD_CODE } from './code'

export class SearchField {
  static RULES_ADDED = {
    terms: [
      value => (Array.isArray(value) ? value.length > 0: !!value) || 'Required.',
    ],
  };
  static RULES = {
    domain: [
      value => !!value || 'Required.',
    ],
  };

  constructor( field, terms ) {
    this.field = field || CONST_SEARCH_FIELD_CODE[0];
    this.terms = terms || null;
  }
}

export class Search {
  static RULES = {
    domain: SearchField.RULES.domain,
    addeds: SearchField.RULES_ADDED,
  };

  constructor( domain, fields = {} ) {
    this.domain = domain || SEARCH_DOMAIN_TYPE_CODE.all;
    this.fields = fields;
    this.addeds = [];
    // this.sortBy = {'', SORT.ASC};

    // if(fields) {
    //   if(Array.isArray(fields)) {
    //     Object.keys(fields).map((field)=>{
    //       return this.addSearchField({field, terms: field[field]});
    //     });
    //   } else {
    //     this.addSearchField(searchFields);
    //   }
    //   // if(Array.isArray(searchFields)) {
    //   //   searchFields.map((searchField) => this.addSearchField(searchField));
    //   // } else {
    //   //   this.addSearchField(searchFields);
    //   // }
    // }
  }

  addField( added ) {
    this.addeds.push(
      added ? new SearchField(added.field, added.terms) : new SearchField()
    );

    return this;
  }

  getFormula(queriedFormula = null) {
    const fieldQuery = Object.keys(this.fields).map((field) => 
      this.__makeFormula(field, this.fields[field])
    ).filter( v => v).join(' AND ');
    
    const addedQuery = this.addeds.map(
      (added) => this.__makeFormula(added.field, added.terms)
    ).filter( v => v).join(' AND ');

    return [fieldQuery, addedQuery, queriedFormula].filter( v => v ).join(' AND ');
  }

  __makeFormula(field, terms) {
    if(!terms || (Array.isArray(terms) && terms.length === 0)) {
      return undefined;
    }
    switch(field) {
      case SEARCH_FIELD_CODE.AD:
      case SEARCH_FIELD_CODE.DP:
      case SEARCH_FIELD_CODE.PD:
        
        if(terms.length === 1) {
          return `${field}:${terms}`
        } else if(terms.length === 2) {
          return `${field}:[${terms.join(' TO ')}]`
        }
        break;

      case SEARCH_FIELD_CODE.IC:
        terms = Array.isArray(terms) ? terms : [terms];
        return `${SEARCH_FIELD_CODE.IC}:(${terms.map((v)=> `"${v}"`).join(' OR ')})`

      case SEARCH_FIELD_CODE.AN:
        return `${field}:"${terms.toUpperCase()}"`;

      case SEARCH_FIELD_CODE.PN:
      case SEARCH_FIELD_CODE.NP:
      case SEARCH_FIELD_CODE.PCTAN:
        return `${field}:"${terms}"`;

      case SEARCH_FIELD_CODE.TI:
      case SEARCH_FIELD_CODE.TOA:
      case SEARCH_FIELD_CODE.CL:
      case SEARCH_FIELD_CODE.DE:
      case SEARCH_FIELD_CODE.PA:
      case SEARCH_FIELD_CODE.IN:
        return `${field}:(${terms})`;

      default:
        return field + ':'
          + ( terms.indexOf(' ') >= 0 ? `"${terms}"` : terms );
    }
  }
}

export class SearchWizard extends Search {
  static RULES = {
    domain: SearchField.RULES.domain,
    fields: {
      FP: SearchField.RULES_ADDED.terms,
      IC: SearchField.RULES_ADDED.terms,
    }
  };

  constructor( domain, fields ) {
    super(domain, fields);
  }
}

export class AdvancedSearch extends Search {
  static RULES = {
    domain: SearchField.RULES.domain,
    // fields: {
    //   FP: SearchField.RULES_ADDED.terms,
    //   IC: SearchField.RULES_ADDED.terms,
    // }
  };

  constructor( domain, fields ) {
    super(domain, fields);
  }
}